export const SearchIcon = () => {
    return (
        <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10.5184 9.69358L13.0168 12.1914L12.1914 13.0168L9.69358 10.5184C8.76417 11.2635 7.60816 11.6687 6.41699 11.667C3.51899 11.667 1.16699 9.31499 1.16699 6.41699C1.16699 3.51899 3.51899 1.16699 6.41699 1.16699C9.31499 1.16699 11.667 3.51899 11.667 6.41699C11.6687 7.60816 11.2635 8.76417 10.5184 9.69358ZM9.34824 9.26074C10.0886 8.49943 10.502 7.47891 10.5003 6.41699C10.5003 4.16066 8.67274 2.33366 6.41699 2.33366C4.16066 2.33366 2.33366 4.16066 2.33366 6.41699C2.33366 8.67274 4.16066 10.5003 6.41699 10.5003C7.47891 10.502 8.49943 10.0886 9.26074 9.34824L9.34824 9.26074Z"
                fill="currentColor"
            />
        </svg>
    );
};
